export default __webpack_public_path__ + "static/media/pszczoly.e0127482.mp3";